import './app/publicPath'

const Vue = window.Vue
Vue.component('FindlyInput', () => import('./app/FindlyInput.vue'))
Vue.component('FindlyFilter', () => import('./app/FindlyFilter.vue'))
Vue.component('FindlyTagList', () => import('./app/FindlyTagList.vue'))
